import React from 'react'
import {connect} from 'react-redux'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import FormControl from '@mui/material/FormControl'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Tab from 'components/Tab'
import Dataset from './Dataset'
import {createCard} from 'modules/modules/actions'
import {updatePlanning} from 'modules/plannings/actions'
import {fieldtype} from 'utils/enums/fieldtype'
import theme from 'utils/enums/theme'


const Tabs = styled.div`
    display: flex;
    margin-bottom: 30px;
`

const tabs = {
    general: {
        code: 'general'
    },
    datasets: {
        code: 'datasets'
    }
}

class PlanningConfig extends React.Component {
    constructor(props) {
        super(props)

        this.fromToFields = props.entities.length ? this.getFields(props.entities[0].id, [fieldtype.datetime]) : []
        const data = props.data ? [...props.data.datasets] : []
        const datasets = []

        if (data.length) {
            data.forEach(item => {
                const dataset = {...item}
                dataset.colorFieldId = item.colorFieldId ? item.colorFieldId : -1
                dataset.filterFieldId = item.filterFieldId ? item.filterFieldId : -1
                datasets.push(dataset)
            })
        } else {
            datasets.push({
                entityId: props.entities[0].id,
                fromFieldId: this.fromToFields.length ? this.fromToFields[0].id : -1,
                durationFieldId: null,
                toFieldId: this.fromToFields.length && this.fromToFields.length > 1 ? this.fromToFields[1].id : -1,
                labelFieldsId: [],
                colorFieldId: -1,
                filterFieldId: -1,
                defaultDuration: '30',
            })
        }

        this.state = {
            colorScheme: props.data ? props.data.colorScheme : theme.palette.id,
            name: props.data ? props.data.name : '',
            tab: tabs.general.code,
            datasets
        }
    }
    
    getFields = (entity, types) => {
        if (entity && types) {
            return this.props.entities.find(obj =>
                obj.id === entity).fields.filter(item =>
                    types.find(type => type === item.uiType))
        } else {
            return []
        }
    }

    handleChangeDatasets = (obj, num) => {
        const datasets = [...this.state.datasets]
        const dataset = {...datasets.find((item, index) => index === num)}
        Object.keys(obj).forEach(item => {
            if (item === 'entityId') {
                this.fromToFields = this.getFields(obj[item], [fieldtype.datetime])

                dataset.entityId = obj[item]
                dataset.fromFieldId = this.fromToFields.length ? this.fromToFields[0].id : -1
                dataset.toFieldId = this.fromToFields.length && this.fromToFields.length > 1 ? this.fromToFields[1].id : -1
                dataset.durationFieldId = null
                dataset.colorFieldId = -1
                dataset.labelFieldsId = []
                dataset.filterFieldId = -1

            } else {
                dataset[item] = obj[item]
            }
        })

        datasets.splice(num, 1, dataset)
        this.setState({ datasets })
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    createDataset = () => {
        if (this.props.entities.length) {
            const datasets = [...this.state.datasets]
            const entities = this.props.entities.filter(entity =>
                !this.state.datasets.find(dataset => dataset.entityId === entity.id))

            this.fromToFields = this.getFields(entities[0].id, [fieldtype.datetime])
            datasets.push({
                entityId: entities[0].id,
                fromFieldId: this.fromToFields.length ? this.fromToFields[0].id : -1,
                durationFieldId: null,
                toFieldId: this.fromToFields.length && this.fromToFields.length > 1 ? this.fromToFields[1].id : -1,
                labelFieldsId: [],
                colorFieldId: -1,
                filterFieldId: -1,
                defaultDuration: '30',
            })

            this.setState({
                datasets
            })
        }
    }

    deleteDataset = (index) => {
        const datasets = [...this.state.datasets]
        datasets.splice(index, 1)
        this.setState({ datasets })
    }

    createCard = () => {
        this.props.createCard({
            moduleId: this.props.currentModule,
            planning: {
                name: this.state.name,
                colorScheme: this.state.colorScheme,
                colors: [],
                datasets: this.state.datasets.map(item => {
                    return {
                        entityId: item.entityId,
                        fromFieldId: item.fromFieldId,
                        toFieldId: item.toFieldId,
                        durationFieldId: item.durationFieldId,
                        colorFieldId: item.colorFieldId === -1 ? null : item.colorFieldId,
                        labelFieldsId: item.labelFieldsId,
                        filterFieldId: item.filterFieldId === -1 ? null : item.filterFieldId,
                        defaultDuration: Number(item.defaultDuration)
                    }
                })
            }
        }, this.props.type)

        this.props.handleClose()
    }

    updatePlanning = () => {
        this.props.updatePlanning({
            name: this.state.name,
            id: this.props.data.id,
            colorScheme: this.state.colorScheme,
            colors: [],
            datasets: this.state.datasets.map(item => {
                return {
                    entityId: item.entityId,
                    fromFieldId: item.fromFieldId,
                    toFieldId: item.toFieldId,
                    durationFieldId: item.durationFieldId,
                    colorFieldId: item.colorFieldId === -1 ? null : item.colorFieldId,
                    labelFieldsId: item.labelFieldsId,
                    filterFieldId: item.filterFieldId === -1 ? null : item.filterFieldId,
                    defaultDuration: Number(item.defaultDuration)
                }
            })
        })

        this.props.setFilter()
        this.props.handleClose()
    }

    render() {
        const {intl} = this.props

        return (
            <React.Fragment>
                <DialogTitle>
					{intl.formatMessage({id: this.props.data ? "planning.edit_planning" : "main.create_pln"})}
                </DialogTitle>
                <DialogContent>
                    <Tabs>
                        {Object.values(tabs).map((item, index) =>
                            <Tab key={index} active={this.state.tab === item.code} onClick={() => this.setState({ tab: item.code })}>
                                {intl.formatMessage({id: `main.planning_settings_${item.code}`})}
                            </Tab>
                        )}
                    </Tabs>
                    <React.Fragment>
                    {this.state.tab === tabs.general.code ?
                        <React.Fragment>
                            <TextField variant="standard"
                                value={this.state.name}
                                onChange={this.handleChange}
                                label={intl.formatMessage({id: "main.label_planning_card"})}
                                sx={{
									marginBottom: '20px',
									width: '100%'
								}}
                                InputLabelProps={{
                                    shrink: true
                                }}
                                inputProps={{
                                    maxLength: global.NAME_MAX_LENGTH,
                                    name: 'name'
                                }}
                            />
                            <FormControl sx={{ marginBottom: '20px', width: '100%'}} variant="standard">
                                <InputLabel shrink={true}>{intl.formatMessage({id: "main.planning_color"})}</InputLabel>
                                <Select
                                    value={this.state.colorScheme}
                                    onChange={this.handleChange}
                                    inputProps={{
                                        name: 'colorScheme'
                                    }}
                                >
                                    {Object.values(theme).map((item, index) =>
                                        <MenuItem key={index} value={item.id}>
                                            {intl.formatMessage({id: `app.colors_${item.name}`})}
                                        </MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </React.Fragment> :
                        <React.Fragment>
                            {this.state.datasets.map((item, index) =>
                                this.props.entities.find(obj => obj.id === item.entityId) &&
                                <Dataset
                                    key={index}
                                    index={index}
                                    entityId={item.entityId}
                                    fromFieldId={item.fromFieldId}
                                    durationFieldId={item.durationFieldId}
                                    toFieldId={item.toFieldId}
                                    labelFieldsId={item.labelFieldsId}
                                    colorFieldId={item.colorFieldId}
                                    filterFieldId={item.filterFieldId}
                                    defaultDuration={item.defaultDuration}
                                    entities={this.props.entities.filter(entity =>
                                        !this.state.datasets.find(dataset => dataset.entityId === entity.id) ||
                                        entity.id === item.entityId)}
                                    handleChange={this.handleChangeDatasets}
                                    count={this.state.datasets.length}
                                    deleteDataset={this.deleteDataset}
                                />
                            )}
                            <Button variant="contained"
                                onClick={this.createDataset}
                                style={{background: '#4cae4c', color: '#FFF', marginTop: '20px'}}
                            >
                                {intl.formatMessage({id: "planning.add_dataset"})}
                            </Button>
                        </React.Fragment>
                    }
                    </React.Fragment>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    {this.props.data ?
                        <Button variant="contained"
                            disabled={!this.state.name ||
                                this.state.name.replace(/\s/g, '') === '' ||
                                !!this.state.datasets.find(item => !item.labelFieldsId.length) ||
                                !!this.state.datasets.find(item => !item.defaultDuration || item.defaultDuration <= 0)
                            }
                            onClick={this.updatePlanning}
                            color="primary"
                        >
                            {intl.formatMessage({id: "app.confirm_save"})}
                        </Button>
                        :
                        <Button variant="contained"
                            disabled={!this.state.name ||
                                this.state.name.replace(/\s/g, '') === '' ||
                                !!this.state.datasets.find(item => !item.labelFieldsId.length) ||
                                !!this.state.datasets.find(item => !item.defaultDuration || item.defaultDuration <= 0)
                            }
                            onClick={this.createCard}
                            color="primary"
                        >
                            {intl.formatMessage({id: "app.confirm_create"})}
                        </Button>
                    }
                </DialogActions>
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({entities}) => ({
    entities: entities.entities
})

export default connect(mapStateToProps, {
    createCard,
    updatePlanning
})(injectIntl(PlanningConfig))
